<!-- <div class="custombg fixed-top">
  <nav aria-label="breadcrumb">

    <ol class="breadcrumb mb-0">
      <li class="breadcrumb-item active" aria-current="page" (click)="goToHome()" style="cursor:pointer">Home &nbsp;
      </li>
      <li class="breadcrumb-item active" style="cursor:pointer" (click)="switchDeckView()">KMS Portal &nbsp;</li>
      <li class="breadcrumb-item active" aria-current="page">{{selectedView.name}} Approvals</li>
    </ol>
  </nav>

</div> -->
<div class="wrapper">
  <div class="container mr-0" *ngIf="permissions.canAddProject">
    <div class="row" align="right">
      <div class="col-12 p-2 mt-2 alignment">
        <div class="btn-group add-project">
          <button type="button" data-toggle="dropdown" data-reference="parent"
            class="btn btn-secondary w-100 add-btn"><i class="fas fa-plus"></i>Add Project </button>
          <button type="button" class="btn btn-secondary dropdown-toggle" id="dropdownMenuReference"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-reference="parent">
            <span class="sr-only">Toggle Dropdown</span>
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuReference">
            <a class="dropdown-item" (click)="onChangeProjectType('Case Studies')">Case Studies</a>
            <a class="dropdown-item" (click)="onChangeProjectType('Corporate Deck')">Others</a>
          </div>
        </div>

        <div class="btn-group add-project">

          <button type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            data-reference="parent" class="btn btn-secondary w-100 add-btn"><i class="fas fa-plus"></i>Bulk Upload
          </button>
          <button type="button" class="btn btn-secondary dropdown-toggle" id="dropdownMenuReference"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-reference="parent">
            <span class="sr-only">Toggle Dropdown</span>
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuReference">
            <a class="dropdown-item" (click)="excelFile1.click()">Case Studies</a>
            <a class="dropdown-item" (click)="excelFile2.click()">Others</a>
            <input style="display: none;" type="file" id="excelFile"
              (change)="handleFileInput($event.target.files,'Case Studies')" #excelFile1 />
            <input style="display: none;" type="file" id="excelFile"
              (change)="handleFileInput($event.target.files,'Others')" #excelFile2 />
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="modal-container">
    <div class="row">
      <div class="col-12 col-md-12 col-lg-12 col-xl-12 p-2 mt-2 ">
        <div class="card margin-bottom-to-footer">
          <!---Title-->
          <div class="row d-flex p-3 m-0 border-bottom">
            <div class="heading_1  mr-auto mb-sm-3 mb-md-3 ">{{selectedView.name}} Approvals</div>
            <div class="dropdown" (document:click)="handleDocumentClick($event)">
              <div class="my-0 mr-2 min_width p-0" [class.show]="true" (click)="stopPropagation($event)">
                <app-multi-filter [contentTypes]="contentTypes" [projectGridViews]="projectGridViews"
                  [selectedView]="selectedView" [organizations]="organizations"
                  [selectedContentType]="selectedContentType" [selectedOrganization]="selectedorganization"
                  (applyFilterAttributes)="applyFilter(); closeFilterDropdown()" [userRole]="userRole"
                  [organizationFlag]="organizationFlag" aria-labelledby="filterdropdown" x-placement="bottom-start">
                </app-multi-filter>
              </div>
            </div>





            <div class=" d-flex input-group">
              <input class="form-control" style="border-right: none;" #searchTerm [(ngModel)]="searchText"
                (keyup.enter)="searchGrid()" id="myInput" type="text" placeholder="Search for Approvals.." [formControl]="search"
                [class.searchClose]="searchText==''">
              <button type="submit" class="search-icon  " (click)="clearSearchText()" *ngIf="searchText"><i
                  class="fa fa-times icon"></i></button>
              <div class="input-group-append">
                <button class="btn btn-outline-secondary searchfield-right btn-search" id="text-search" type="button"><i
                    class="fas fa-search search" (click)="searchGrid()"></i></button>
              </div>
            </div>
          </div>
          <!---row loop-->
          <div *ngIf="selectedContentType === 'Case Studies';else ictView">
            <div *ngIf="allProjects && allProjects.length > 0;else showMessage">
              <div class="row p-3 m-0 border-bottom" *ngFor="let attachment of allProjects; let i=index;">
                <div class="col p-0">
                  <div class="row">
                    <div class="col-12 col-md-1 col-lg-1 text-truncate"
                      *ngIf="userRole === 'SuperAdmin' || userRole === 'Admin'">
                      <div class="pr-2 mt-3">
                        <mat-checkbox color="primary" (change)="addToDeleteList(attachment,$event)"></mat-checkbox>
                      </div>
                    </div>
                    <div class="col-12 col-md-3 col-lg-3 text-truncate">
                      <div class="pr-2">
                        <div><span class="secondaryInfo">Project Name </span></div>
                        <div class=" text-truncate">
                          <span class="heading_3" matTooltip="{{attachment.projectName}}"
                           placement="bottom">{{attachment.projectName}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-2 col-lg-2 text-truncate">
                      <div class="pr-2">
                        <div><span class="secondaryInfo">Project Manager</span></div>
                        <div class="text-truncate">
                          <span class="heading_3"  matTooltip="{{attachment.projectManager}}" 
                          placement="bottom">{{attachment.projectManager}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-3 col-lg-3 text-truncate"
                      [ngClass]="{'col-md-2 col-lg-2':attachment.versionsCount}">
                      <div class="pr-2">
                        <div><span class="secondaryInfo">Sales Contact</span></div>
                        <div class="text-truncate">
                          <span class="heading_3" matTooltip="{{attachment.bdContact}}" 
                          placement="bottom">{{attachment.bdContact}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="text-truncate" [ngClass]="{'col-md-2 col-lg-2':attachment.versionsCount}">
                      <div class="pr-2">
                        <div><span class="secondaryInfo">Location</span></div>
                        <div class="text-truncate "><span class="heading_3" matTooltip="{{attachment.geography}}"
                           placement="bottom">{{attachment.geography}}</span></div>
                      </div>
                    </div>
                    <div class="col-12 col-md-1 col-lg-1 text-truncate" *ngIf="attachment.versionsCount">
                      <div class="pr-2">
                        <div><span class="secondaryInfo">Versions</span></div>
                        <div class="text-truncate"><span class="heading_3"  matTooltip="{{attachment.versionsCount}}"
                           placement="bottom">{{attachment.versionsCount}} <i
                              *ngIf="attachment.versionsCount > 1" class="fas fa-angle-double-down mx-2"
                              [ngClass]="{'fa-angle-double-up':attachment.showVersions}"
                              (click)="toggleShowVersions(i)"></i></span></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-auto d-flex p-0 border-left">

                  <div class="buttons_column align-self-center  p-0">
                    <i *ngIf="permissions.canViewProject && !permissions.canApproveProject" class="fas fa-eye m-2"
                      title="View" (click)="navigate(attachment.id , true)">
                    </i>
                    <i *ngIf="permissions.canUpdateProject"
                      [title]="permissions.canApproveProject ? 'Edit & Approve' : 'Edit'"
                      [routerLink]="['../editProject/',attachment.id]" class="fas fa-edit  m-2"></i>
                    <i *ngIf="permissions.canApproveProject" title="View & Approve"
                      class="fas fa-check-circle m-2 approve" (click)="navigate(attachment.id , true)"
                      data-keyboard="false"></i>
                    <i *ngIf="permissions.canDeleteProject" title="Delete" class="fas fa-trash-alt m-2"
                      (click)="deleteProject(attachment.id)" data-keyboard="false"></i>
                  </div>
                </div>
                <div class="col-12 versions my-4 " *ngIf="attachment.showVersions">
                  <div class="row p-3 m-0 border-bottom" *ngFor="let version of attachment.versions">
                    <div class="col p-0">
                      <div class="row">
                        <div class="col-12 col-md-1 col-lg-1 text-truncate"
                          *ngIf="userRole === 'SuperAdmin' || userRole === 'Admin'">
                          <div class="pr-2 mt-3">
                            <mat-checkbox color="primary" (change)="addToDeleteList(version,$event)"></mat-checkbox>
                          </div>
                        </div>
                        <div class="col-12 col-md-3 col-lg-3 text-truncate">
                          <div class="pr-2">
                            <div><span class="secondaryInfo">Project Name </span></div>
                            <div class=" text-truncate"><span class="heading_3" matTooltip="{{version.projectName}}" 
                              placement="bottom">{{version.projectName}}</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-md-2 col-lg-2 text-truncate">
                          <div class="pr-2">
                            <div><span class="secondaryInfo">Project Manager</span></div>
                            <div class="text-truncate"><span class="heading_3" matTooltip="{{version.projectManager}}" 
                              placement="bottom">{{version.projectManager}}</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-md-3 col-lg-3 text-truncate"
                          [ngClass]="{'col-md-2 col-lg-2':version.versionsCount}">
                          <div class="pr-2">
                            <div><span class="secondaryInfo">Sales Contact</span></div>
                            <div class="text-truncate"><span class="heading_3" matTooltip="{{version.bdContact}}" 
                              placement="bottom">{{version.bdContact}}</span></div>
                          </div>
                        </div>
                        <div class=" pl-md-0 col-md-2 col-lg-2 text-truncate">
                          <div class="pr-2">
                            <div><span class="secondaryInfo">Location</span></div>
                            <div class="text-truncate "><span class="heading_3" matTooltip="{{version.geography}}"
                                placement="bottom">{{version.geography}}</span></div>
                          </div>
                        </div>
                        <!-- <div class="col-12 col-md-1 col-lg-1 text-truncate">
                        <div class="pr-2">
                          <div><span class="secondaryInfo">Version</span></div>
                          <div class="text-truncate text-center"><span class="heading_3 dot"
                              matTooltip="{{version.version}}" matTooltipPosition="left">{{version.version}}</span>
                          </div>
                        </div>
                      </div> -->
                      </div>
                    </div>
                    <div class="col-auto d-flex p-0 border-left">

                      <div class="buttons_column align-self-center  p-0">
                        <i *ngIf="permissions.canViewProject" class="fas fa-eye m-2" title="View"
                          (click)="navigate(attachment.id)">
                        </i>
                        <i *ngIf="permissions.canUpdateProject"
                          [title]="permissions.canApproveProject ? 'Edit & Approve' : 'Edit'"
                          [routerLink]="['../editProject/',attachment.id]" class="fas fa-edit  m-2"></i>
                        <i *ngIf="permissions.canApproveProject" title="View & Approve"
                          class="fas fa-check-circle m-2 approve" (click)="navigate(attachment.id)"
                          data-keyboard="false"></i>
                        <i *ngIf="permissions.canDeleteProject" title="Delete" class="fas fa-trash-alt m-2"
                          (click)="deleteProject(attachment.id)" data-keyboard="false"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <span class="next-tab" (click)="next()">next</span>
            <span class="previous-tab" (click)="previous()"> previous</span> -->
            </div>

            <div class="row">
              <div class="col-3">
                <div class="center" style="margin-top: 1rem;margin-left: 1rem;">
                  <p>
                    <span *ngIf="projectCount && currentPage">
                      {{projectCount}}
                      records
                    </span>
                  </p>
                </div>
              </div>

              <!-- Pagination -->
              <!-- <div class="col-9" *ngIf="projectCount > size">
                <div class=" my-3 mr-3 floatRight">
                  <nav aria-label="Page navigation example">
                    <ul class="pagination justify-content-center" style="float: right;" *ngIf="pages">
                      <li class="page-item ">
                        <a class="page-link active" (click)="previous()" tabindex="-1">Previous</a>
                      </li>
                      <li class="page-item" *ngFor="let page of pages; let i = index"><a
                          *ngIf="i+1 <= lastPage  && i+1 > firstPage" class="page-link"
                          [ngClass]="{'text-primary':page == currentPage}" (click)="loadMore(page)">{{
                                    page}}</a></li>
                      <li class="page-item">
                        <a class="page-link active" (click)="next()">Next</a>
                      </li>
                    </ul>
                  </nav> -->
              <!-- <div class="center col-9 " style="margin-top: 1rem;" *ngIf="projectCount > size">
                    <div class="my-3 mr-3 floatleft my-pagination-container">
                      <nav style="margin-left: 45rem;" aria-label="Page navigation example">
                        <ul class="pagination justify-content-center" *ngIf="pages">
                          <li class="page-item">
                            <a class="page-link custom-pagination-link" style="min-width:50px ;  margin-left: auto;
                            margin-right: auto; " (click)="previous()">Previous</a>
                          </li>
                          <li class="page-item" *ngFor="let page of pages; let i = index">
                            <a *ngIf="i + 1 <= lastPage && i + 1 > firstPage" class="page-link custom-pagination-link"
                              style="width:20px;margin-left: auto;
                              margin-right: auto; padding-right: 15px;" [ngClass]="{'text-primary': page == currentPage}" (click)="loadMore(page)">
                              {{ page }}
                            </a>
                          </li>
                          <li class="page-item" >
                            <a class="page-link custom-pagination-link" style="min-width:50px; margin-right: auto; margin-left: auto;" (click)="next()">Next</a>
                          </li>
                        </ul>
                      </nav> -->
              <div class="center col-9 page" *ngIf="projectCount > size">
                <div class="my-3 mr-3 floatleft my-pagination-container">
                  <nav style="margin-left: 40rem;" aria-label="Page navigation example" *ngFor="let page of pages;">
                    <ul class="pagination justify-content-center" *ngIf="pages">
                      <li class="page-item" [class.disabled]="isFirstPage()">
                        <a class="page-link custom-pagination-link"
                          style="min-width:50px; margin-left: auto; margin-right: auto;"
                          (click)="previous()">Previous</a>
                      </li>

                      <ng-container *ngIf="(totalPages >= 5) && (currentPage >= 3)">
                        <li class="page-item">
                          <span class="page-link custom-pagination-link">...</span>
                        </li>
                      </ng-container>

                      <ng-container *ngFor="let page of pages">
                        <li class="page-item"
                          *ngIf="(totalPages < 5) || ((currentPage - 1 <= page) && (page <= currentPage + 1))"
                          (click)="loadMore(page)">
                          <a class="page-link custom-pagination-link"
                            [style.color]="page === currentPage ? 'blue' : 'black'">{{ page }}</a>
                        </li>
                      </ng-container>

                      <ng-container
                        *ngIf="(((totalPages >= 5) && (currentPage < (totalPages - 2)) && (currentPage < pages.length -1)))">
                        <li class="page-item">
                          <span class="page-link custom-pagination-link">...</span>
                        </li>
                      </ng-container>


                      <li class="page-item" [class.disabled]="isLastPage()">
                        <a class="page-link custom-pagination-link"
                          style="min-width:50px; margin-right: auto; margin-left: auto;" (click)="next()">Next</a>
                      </li>
                    </ul>
                  </nav>
                  <!-- <button class="btn btn-primary add-btn""> previous</button>
                                <button class="btn btn-primary add-btn ml-3" >next</button> -->
                </div>
              </div>
            </div>
            <ng-template #showMessage>
              <p class="text-center">No projects found</p>
            </ng-template>
          </div>
          <ng-template #ictView>
            <div *ngIf="allProjects && allProjects.length > 0;else showMessage">
              <div class="row p-3 m-0 border-bottom" *ngFor="let attachment of allProjects; let i=index;">
                <div class="col p-0">
                  <div class="row">
                    <div class="col-12 col-md-1 col-lg-1 text-truncate"
                      *ngIf="userRole === 'SuperAdmin' || userRole === 'Admin'">
                      <div class="pr-2 mt-3">
                        <mat-checkbox color="primary" (change)="addToDeleteList(attachment,$event)"></mat-checkbox>
                      </div>
                    </div>
                    <div class="col-12 col-md-3 col-lg-3 text-truncate">
                      <div class="pr-2">
                        <div><span class="secondaryInfo">Deck Name </span></div>
                        <div class=" text-truncate">
                          <span class="heading_3"  matTooltip="{{attachment.projectName}}"  
                          placement="bottom">{{attachment.projectName}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-2 col-lg-2 text-truncate">
                      <div class="pr-2">
                        <div><span class="secondaryInfo">Description</span></div>
                        <div class="text-truncate"><span class="heading_3"  matTooltip="{{attachment.description}}"  
                          placement="bottom">{{attachment.description}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-3 col-lg-3 text-truncate"
                      [ngClass]="{'col-md-2 col-lg-2':attachment.versionsCount}">
                      <div class="pr-2">
                        <div><span class="secondaryInfo">Purpose Of Usage</span></div>
                        <div class="text-truncate"><span class="heading_3" matTooltip="{{attachment.purposeOfUsage}}"  
                          placement="bottom">{{attachment.purposeOfUsage}}</span></div>
                      </div>
                    </div>

                    <div class="col-12 col-md-1 col-lg-1 text-truncate" *ngIf="attachment.version">
                      <div class="pr-2">
                        <div><span class="secondaryInfo">Versions</span></div>
                        <div class="text-truncate"><span class="heading_3"  matTooltip="{{attachment.version}}" 
                          placement="bottom">{{attachment.version}} <i
                              *ngIf="attachment.version > 1" class="fas fa-angle-double-down mx-2"
                              [ngClass]="{'fa-angle-double-up':attachment.version}"
                              (click)="toggleShowVersions(i)"></i></span></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-auto d-flex p-0 border-left">

                  <div class="buttons_column align-self-center  p-0">
                    <i *ngIf="ictPermissions.canViewProject" class="fas fa-eye m-2" title="View"
                      (click)="navigateToICT(attachment.id)">
                    </i>
                    <i *ngIf="ictPermissions.canUpdateProject"
                      [title]="permissions.canApproveProject ? 'Edit & Approve' : 'Edit'"
                      [routerLink]="['/Home/KMSPortal/'+selectedContentType+'/edit/',attachment.id]" class="fas fa-edit  m-2"></i>
                    <i *ngIf="ictPermissions.canApproveProject" title="View & Approve"
                      class="fas fa-check-circle m-2 approve" (click)="navigateToICT(attachment.id)"
                      data-keyboard="false"></i>
                    <i *ngIf="ictPermissions.canDeleteProject" title="Delete" class="fas fa-trash-alt m-2"
                      (click)="deleteICTProjectHistory(attachment.id)" data-keyboard="false"></i>
                  </div>
                </div>
                <div class="col-12 versions my-4 " *ngIf="attachment.showVersions">
                  <div class="row p-3 m-0 border-bottom" *ngFor="let version of attachment.versions">
                    <div class="col p-0">
                      <div class="row">
                        <div class="col-12 col-md-1 col-lg-1 text-truncate"
                          *ngIf="userRole === 'SuperAdmin' || userRole === 'Admin'">
                          <div class="pr-2 mt-3">
                            <mat-checkbox color="primary" (change)="addToDeleteList(version,$event)"></mat-checkbox>
                          </div>
                        </div>
                        <div class="col-12 col-md-3 col-lg-3 text-truncate">
                          <div class="pr-2">
                            <div><span class="secondaryInfo">Deck Name </span></div>
                            <div class=" text-truncate">
                              <span class="heading_3" matTooltip="{{version.projectName}}" 
                              placement="bottom">{{version.projectName}}</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-md-2 col-lg-2 text-truncate">
                          <div class="pr-2">
                            <div><span class="secondaryInfo">Description</span></div>
                            <div class="text-truncate"><span class="heading_3" matTooltip="{{version.description}}" 
                              placement="bottom">{{version.description}}</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-md-3 col-lg-3 text-truncate"
                          [ngClass]="{'col-md-2 col-lg-2':version.versionsCount}">
                          <div class="pr-2">
                            <div><span class="secondaryInfo">Purpose Of Usage</span></div>
                            <div class="text-truncate"><span class="heading_3" matTooltip="{{version.purposeOfUsage}}" 
                              placement="bottom">{{version.purposeOfUsage}}</span></div>
                          </div>
                        </div>
                        <!-- <div class=" pl-md-0 col-md-2 col-lg-2 text-truncate">
                          <div class="pr-2">
                            <div><span class="secondaryInfo">Location</span></div>
                            <div class="text-truncate "><span class="heading_3" matTooltip="{{version.geography}}"
                                matTooltipPosition="left">{{version.geography}}</span></div>
                          </div>
                        </div> -->
                        <!-- <div class="col-12 col-md-1 col-lg-1 text-truncate">
                        <div class="pr-2">
                          <div><span class="secondaryInfo">Version</span></div>
                          <div class="text-truncate text-center"><span class="heading_3 dot"
                              matTooltip="{{version.version}}" matTooltipPosition="left">{{version.version}}</span>
                          </div>
                        </div>
                      </div> -->
                      </div>
                    </div>
                    <div class="col-auto d-flex p-0 border-left">

                      <div class="buttons_column align-self-center  p-0">
                        <i *ngIf="permissions.canViewProject" class="fas fa-eye m-2" title="View"
                          (click)="navigateToICT(attachment.id)">
                        </i>
                        <i *ngIf="permissions.canUpdateProject"
                          [title]="permissions.canApproveProject ? 'Edit & Approve' : 'Edit'"
                          [routerLink]="['/Home/KMSPortal/'+selectedContentType+'/edit/',attachment.id]" class="fas fa-edit  m-2"></i>
                        <i *ngIf="permissions.canApproveProject" title="View & Approve"
                          class="fas fa-check-circle m-2 approve" (click)="navigateToICT(attachment.id)"
                          data-keyboard="false"></i>
                        <i *ngIf="permissions.canDeleteProject" title="Delete" class="fas fa-trash-alt m-2"
                          (click)="deleteICTProjectHistory(attachment.id)" data-keyboard="false"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <span class="next-tab" (click)="next()">next</span>
            <span class="previous-tab" (click)="previous()"> previous</span> -->
            </div>

            <div class="row">
              <div class="col-3">
                <div class="center" style="margin-top: 1rem;margin-left: 1rem;">
                  <p>
                    <span *ngIf="projectCount && currentPage">
                      {{projectCount}}
                      records
                    </span>
                  </p>
                </div>
              </div>

              <!-- Pagination -->
              <div class="col-9" *ngIf="projectCount > size">
                <div class=" my-3 mr-3 floatRight">
                  <nav aria-label="Page navigation example">
                    <ul class="pagination justify-content-center" style="float: right;" *ngIf="pages">
                      <li class="page-item ">
                        <a class="page-link active" (click)="previous()" tabindex="-1">Previous</a>
                      </li>
                      <li class="page-item" *ngFor="let page of pages; let i = index"><a
                          *ngIf="i+1 <= lastPage  && i+1 > firstPage" class="page-link"
                          [ngClass]="{'text-primary':page == currentPage}" (click)="loadMore(page)">{{
                          page}}</a></li>
                      <li class="page-item">
                        <a class="page-link active" (click)="next()">Next</a>
                      </li>
                    </ul>
                  </nav>
                  <!-- <button class="btn btn-primary add-btn""> previous</button>
                                <button class="btn btn-primary add-btn ml-3" >next</button> -->
                </div>
              </div>
            </div>

            <ng-template #showMessage>
              <p class="text-center">No projects found</p>
            </ng-template>
          </ng-template>

        </div>
      </div>
    </div>
  </div>
</div>
<!-- </div> -->
<div #actions class="actions">
  <div>
    <i class="far fa-trash-alt whiteFont" (click)="deleteMultipleProjects()"></i>
  </div>
</div>

<!-- <div class="overlay" (click)="dismissSidebar()"></div> -->